import _isArrayBuffer from "lodash/isArrayBuffer";
import _isString from "lodash/isString";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import { showError } from 'components';
export var showApiError = function showApiError(err) {
  var _ref, _ref2, _error$data$error, _error, _error$data, _error2, _error2$data, _error3, _error4;

  var defaultMessage = 'Възникна проблем, моля опитайте пак!';
  var error = err;

  if (_isArrayBuffer(err.data)) {
    var message = String.fromCharCode.apply(null, new Uint8Array(err.data));
    error = {
      data: _isString(message) ? JSON.parse(message) : defaultMessage
    };
  }

  var errorMessage = (_ref = (_ref2 = (_error$data$error = (_error = error) === null || _error === void 0 ? void 0 : (_error$data = _error.data) === null || _error$data === void 0 ? void 0 : _error$data.error) !== null && _error$data$error !== void 0 ? _error$data$error : (_error2 = error) === null || _error2 === void 0 ? void 0 : (_error2$data = _error2.data) === null || _error2$data === void 0 ? void 0 : _error2$data.message) !== null && _ref2 !== void 0 ? _ref2 : (_error3 = error) === null || _error3 === void 0 ? void 0 : _error3.data) !== null && _ref !== void 0 ? _ref : (_error4 = error) === null || _error4 === void 0 ? void 0 : _error4.statusText;
  showError(_isString(errorMessage) ? errorMessage : defaultMessage);
};